import React from 'react';
import WorkflowApp from './WorkflowApp';

const WorkflowAI = () => {
  return (
    <div className="flex flex-col h-screen bg-dark-bg text-dark-text-primary">
      <WorkflowApp />
    </div>
  );
};

export default WorkflowAI;